import { render, staticRenderFns } from "./checkInWithGift.vue?vue&type=template&id=ec799e56&scoped=true&"
import script from "./checkInWithGift.vue?vue&type=script&lang=js&"
export * from "./checkInWithGift.vue?vue&type=script&lang=js&"
import style0 from "./checkInWithGift.vue?vue&type=style&index=0&id=ec799e56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec799e56",
  null
  
)

export default component.exports